import { setCookie } from '../helpers/VanillaCookie';

const ONE_MINUTE = 60000;

import { trackAction } from 'helpers/trackingOM';

export default class GeoLocationService {
    constructor() {
        this.maxAge = ONE_MINUTE * 60;
        this.cookiename = 'latlon';
    }

    fetchLocation(useFallback = false) {
        let self = this;
        return new Promise((resolve, reject) => {
            let location;
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            if (urlParams.has(this.cookiename)) {
                self.__setCookie(urlParams.get(this.cookiename));
            }
            location = self.__getFromCookie();
            if (location !== null) {
                resolve(location);
                return;
            }
            // if we already have location in cache, then gtfo
            location = self.__getFromCache();
            if (location !== null) {
                resolve(location);
                return;
            }

            // try to fetch location
            if (!useFallback && navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    function (location) {
                        if (
                            location &&
                            location.coords &&
                            location.coords.latitude &&
                            location.coords.longitude
                        ) {
                            let locationObj = self._parseLocationObj(location);
                            self.__saveToCache(locationObj);
                            resolve(locationObj);
                            // allow exception in case user ignored or clicked x without explicitly blocking location share
                            if (sessionStorage.getItem('hasTrackedLocationShare')) {
                                sessionStorage.removeItem('hasTrackedLocationShare');
                            }
                            self._trackLocationShare(false);
                        } else {
                            self.__fallback(resolve, reject);
                        }
                    },
                    function () {
                        self.__fallback(resolve, reject);
                    },
                    { timeout: 10000, maximumAge: self.maxAge, enableHighAccuracy: false },
                );
            } else {
                self.__fallback(resolve, reject);
            }
        });
    }

    __getFromCookie() {
        let match = document.cookie.match(new RegExp('(^| )' + this.cookiename + '=([^;]+)'));
        if (match) {
            let coords = decodeURIComponent(match[2]).split(',');
            return {
                coords: {
                    latitude: coords[0],
                    longitude: coords[1],
                },
            };
        } else {
            return null;
        }
    }

    __setCookie(latlon) {
        const latRegex = /^-?([0-8]?[0-9]|90)(\.[0-9]{1,10})?$/;
        const lonRegex = /^-?([0-9]{1,2}|1[0-7][0-9]|180)(\.[0-9]{1,10})?$/;
        let coords = latlon.split(',');
        if (latRegex.test(coords[0]) && lonRegex.test(coords[1])) {
            setCookie(this.cookiename, latlon, {
                expires: 0,
                path: '/',
            });
        }
    }

    _trackLocationShare(isFallback) {
        let hasTrackedLocationShare = sessionStorage.getItem('hasTrackedLocationShare'),
            trackingAction = isFallback
                ? 'trackShareLocationDisabled'
                : 'trackShareLocationEnabled',
            trackingObj = {
                locationShared: Number(!isFallback).toString(),
            };
        // only track once
        if (!hasTrackedLocationShare) {
            trackAction(trackingAction, trackingObj);
            sessionStorage.setItem('hasTrackedLocationShare', 1);
        }
    }

    _parseLocationObj(raw) {
        let lat = +(raw.coords ? raw.coords.latitude : raw.location.lat);
        let lng = +(raw.coords ? raw.coords.longitude : raw.location.lng);
        let obj = {
            coords: {
                latitude: lat.toFixed(2),
                longitude: lng.toFixed(2),
            },
            isFallback: typeof raw.isFallback !== 'undefined',
        };
        return obj;
    }

    /**
     * @param posObj
     * @private
     */
    __saveToCache(posObj) {
        let cache = {
            pos: posObj,
            expires: new Date().getTime() + this.maxAge,
        };

        window.sessionStorage.setItem('geo_cache', JSON.stringify(cache));
    }

    /**
     * @returns {null|*}
     * @private
     */
    __getFromCache() {
        let cache = window.sessionStorage.getItem('geo_cache');
        if (cache) {
            let cacheObj = JSON.parse(cache);
            if (cacheObj && cacheObj.pos && cacheObj.expires > new Date().getTime()) {
                return cacheObj.pos;
            }
        }

        return null;
    }

    /**
     * If browser location detection not supports
     * @private
     */
    __fallback(resolve, reject) {
        let self = this;

        self._trackLocationShare(true);

        if (!!CBS.Registry.Features?.geo_location_google_api) {
            self.__fetchLatLngWithGoogleApi(resolve, reject);
            return;
        }

        self.__fetchLatLngWithMaxmind(resolve, reject);
    }

    __fetchLatLngWithGoogleApi(resolve, reject) {
        let self = this;

        $.post(
            'https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyBHfXqKCjfVvt8hBsZ36kZTWEr6sr0SFuA',
            function (resp) {
                if (resp && resp.location && resp.location.lat && resp.location.lng) {
                    resp['isFallback'] = 1;
                    let locationObj = self._parseLocationObj(resp);
                    self.__saveToCache(locationObj);
                    resolve(locationObj);
                } else {
                    reject();
                }
            },
            'json',
        ).fail(function () {});
    }

    __fetchLatLngWithMaxmind(resolve, reject) {
        if (
            CBS.Registry.defaultGeolocation &&
            (!CBS.Registry.geoLoc?.lat || !CBS.Registry.geoLoc?.lng)
        ) {
            const locationObj = this._parseLocationObj({
                location: {
                    lat: 40.7128,
                    lng: -74.006,
                },
            });
            resolve(locationObj);
            return;
        } else if (!CBS.Registry.geoLoc?.lat || !CBS.Registry.geoLoc?.lng) {
            reject();
            return;
        }

        const locationObj = this._parseLocationObj({
            location: {
                ...CBS.Registry.geoLoc,
            },
        });

        resolve(locationObj);
    }
}
